// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__DDa+V"};